
























import {Vue, Component, Prop} from 'vue-property-decorator'
import {$} from '@/facade'

@Component({
  computed: {
    $() {
      return $
    },
  },
})
export default class InvocationTooltip extends Vue {
  @Prop({type: String, required: true}) type!: 'smart contracts' | 'dApps'

  get tooltip() {
    return $.translate('components.InvocationTooltip.tooltip', {
      type: this.type,
    })
  }
}
